import { EDayOfWeek } from '../Enum/EDayOfWeek';
import { EMonth } from '../Enum/EMonth';
import { ERating } from '../Enum/ERating';
import { EDeliveryState } from '../Enum/EDeliveryState';
import { EUserRole } from '../Enum/EUserRole';
import { EComplaintTemplateDirection } from '../Enum/EComplaintTemplateDirection';
import { EEntityType } from '../Enum/EEntityType';
import { ETenderOperationType } from '../Enum/ETenderOperationType';
import { ETenderState } from '../Enum/ETenderState';
import { EComplaintState } from '../Enum/EComplaintState';
import { EComplaintCommentState } from '../Enum/EComplaintCommentState';
import { ECalendarEntryType } from '../Enum/ECalendarEntryType';
import { EReportType } from '../Enum/EReportType';
import { ERequestForDeliveryAssigner} from '../Enum/ERequestForDeliveryAssigner';
import { ERestorePasswordResult} from '../Enum/ERestorePasswordResult';
import { ERegisterResult} from '../Enum/ERegisterResult';
import { EUpdatePasswordResult} from '../Enum/EUpdatePasswordResult';
import { ERoutePointType} from '../Enum/ERoutePointType';
import { ERatingType} from '../Enum/ERatingType';
import { EApiRequestDirection } from '../Enum/EApiRequestDirection';
import { EComplaintCommentDirection } from '../Enum/EComplaintCommentDirection';
import { EDeliveryCompletionState } from '../Enum/EDeliveryCompletionState';
import { EWithdrawOwner } from '../Enum/EWithdrawOwner';
import { EDriverScoreKind } from '../Enum/EDriverScoreKind';
import { EDeliveryStateSource } from '../Enum/EDeliveryStateSource';
import { ECargoTransporterRatingReportType } from '../Enum/ECargoTransporterRatingReportType';
import { EOperationType } from '../Enum/EOperationType';
import { ExtraInformationDTO } from './ExtraInformationDTO';
import { TimeDTO } from './TimeDTO';
import { GeoCoordinateDTO } from './GeoCoordinateDTO';



export class RouteSegmentDTO {
	public OrderNum?: number = undefined;
	public PointType?: ERoutePointType = undefined;
	public LoadingPointId?: string = undefined;
	public UnloadingPointId?: string = undefined;
	public HandlingTypeId?: string = undefined;
	public HandlingTypeName?: string = undefined;
	public PayloadId?: string = undefined;
	public CustomPoint?: string = undefined;
	public ArrivalDateStart?: Date = undefined;
	public ArrivalDateEnd?: Date = undefined;
	public ArrivalDate?: Date = undefined;
	public ExtraInformation?: ExtraInformationDTO[] = undefined;
	public CustomPointCoordinates?: GeoCoordinateDTO = undefined;
	public Registered?: boolean = undefined;
	public RegisteredWithLate?: boolean = undefined;
	public Id?: string = undefined;
}
 
